import React from "react";
import Dwt from "./dwtMain"
import MainPageDialog from "../dialog";
const DwtPopup = ({ setFileFromScanner, showScannerPopup,setShowScannerPopup ,fileUploadFunction}) => {
  console.log(showScannerPopup,"showScannerPopup")
  return (
    <MainPageDialog
      footerList={[
        {
          title: "Close",
          action: () => {
            setShowScannerPopup(false);
          },
          type: "cancel",
        },
      ]}
      title="Scan Document"
      onCancelHandler={() => {
        setShowScannerPopup(false);
      }}
    >
    {showScannerPopup && <Dwt fileUploadFunction={fileUploadFunction}/> } 
    </MainPageDialog>
  );
};

export default DwtPopup;
